module.exports = __webpack_public_path__ + "static/digital-85fd616601a6e6781b4c158c26e5d709.jpg";